/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportDocuments } from '../../models/export-documents';

export interface ExportDocumentsGetDocumentList$Params {
  page?: number;
  PatientID?: string | null;
  PracticeId?: string | null;
  DateFrom?: string | null;
  dateTo?: string | null;
}

export function exportDocumentsGetDocumentList(http: HttpClient, rootUrl: string, params?: ExportDocumentsGetDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportDocuments>> {
  const rb = new RequestBuilder(rootUrl, exportDocumentsGetDocumentList.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('PatientID', params.PatientID, {});
    rb.query('PracticeId', params.PracticeId, {});
    rb.query('DateFrom', params.DateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportDocuments>;
    })
  );
}

exportDocumentsGetDocumentList.PATH = '/exportdocument/emrlist';
